import React from 'react';
import PropTypes from 'prop-types';
import OverflowDetector from './OverflowDetector';
import SearchResultBarItem from './SearchResultBarItem';
import { Message } from '@aperza/ui';
import { AppService, AppConfigService } from '@aperza/util';
const appConfig = AppService.appConfig();
class SearchResultBarContent extends React.Component {
    handleOverflowChange(isOverflowed) {
        if (this.props.onOverflowChange) {
            this.props.onOverflowChange(isOverflowed);
        }
    }
    render() {
        let { viewer } = this.props;
        let searchModel = viewer && viewer.searchModel ? viewer.searchModel : {};
        let searchItem = viewer && viewer.searchItem ? viewer.searchItem : {};
        let searchCatalog = viewer && viewer.searchCatalog ? viewer.searchCatalog : {};
        let searchNews = viewer && viewer.searchNews ? viewer.searchNews : {};
        let keyword = AppConfigService.getSearchKeyword();
        let searchModelCount = searchModel.count;
        let searchItemCount = searchItem.count;
        let searchCatalogCount = searchCatalog.count;
        let searchNewsCount = searchNews.count;
        let params = AppConfigService.getSearchParams();
        let paramKeyCount = 0;
        Object.keys(params).forEach((key) => {
            if (['fb', 'fc', 'fs', 'fo'].indexOf(key) != -1) {
                paramKeyCount++;
            }
        });
        if (params.fop && params.fop == 'true') {
            paramKeyCount++;
        }
        //Disable for now https://aperza.atlassian.net/browse/AB-5810
        //TODO to remove this section completely
        // if (AppConfigService.isSearchModel() && paramKeyCount > 0) {
        //   searchModelCount = '-';
        // } else if (AppConfigService.isSearchItem() && paramKeyCount > 0) {
        //   searchItemCount = '-';
        // } else if (AppConfigService.isSearchCatalog() && paramKeyCount > 0) {
        //   searchCatalogCount = '-';
        // } else if (AppConfigService.isSearchNews() && paramKeyCount > 0) {
        //   searchNewsCount = '-';
        // }
        let style = {
            justifyContent: 'space-between',
            overflowX: 'auto',
        };
        if (this.props.margin) {
            style.margin = this.props.margin;
        }
        return (React.createElement(OverflowDetector, { onOverflowChange: this.handleOverflowChange.bind(this), className: "strip", style: style },
            React.createElement("div", { className: "strip" },
                React.createElement(SearchResultBarItem, { title: React.createElement(Message, { messageId: "searchResultBar.model" }), count: searchModelCount, selected: AppConfigService.isSearchModel(), url: `https://www${appConfig.baseComDomain}/${appConfig.langCode}/s/model/?k=${encodeURIComponent(keyword)}&rf=1109` }),
                React.createElement(SearchResultBarItem, { title: React.createElement(Message, { messageId: "searchResultBar.catalog" }), count: searchCatalogCount, selected: AppConfigService.isSearchCatalog(), url: `https://www${appConfig.baseComDomain}/${appConfig.langCode}/s/catalog/?k=${encodeURIComponent(keyword)}&rf=1110` }),
                React.createElement(SearchResultBarItem, { title: React.createElement(Message, { messageId: "searchResultBar.item" }), count: searchItemCount, selected: AppConfigService.isSearchItem(), url: `https://ec${appConfig.baseComDomain}/${appConfig.langCode}/s/item/?k=${encodeURIComponent(keyword)}&rf=1112` }),
                React.createElement(SearchResultBarItem, { title: React.createElement(Message, { messageId: "searchResultBar.news" }), count: searchNewsCount, selected: AppConfigService.isSearchNews(), url: `https://www${appConfig.baseDomain}/${appConfig.langCode}/s/news/?k=${encodeURIComponent(keyword)}&rf=1113` }))));
    }
}
SearchResultBarContent.propTypes = {
    viewer: PropTypes.shape({
        searchModel: PropTypes.shape({
            count: PropTypes.number,
        }),
        searchItem: PropTypes.shape({
            count: PropTypes.number,
        }),
        searchCatalog: PropTypes.shape({
            count: PropTypes.number,
        }),
    }),
    margin: PropTypes.string,
    onOverflowChange: PropTypes.func,
};
export default SearchResultBarContent;
// export default createFragmentContainer(SearchResultBarContent, {
//   viewer: graphql`
//     fragment SearchResultBarContent_viewer on Viewer
//       @argumentDefinitions(params: { type: "String" }) {
//       searchModel(params: $params) {
//         count
//       }
//       searchItem(params: $params) {
//         count
//       }
//       searchCatalog(params: $params) {
//         count
//       }
//       searchNews(params: $params) {
//         count
//       }
//     }
//   `,
// });
